module.exports = __webpack_public_path__ + "img/br.c834cb5b.svg";